export const isDevelopment = ['development', 'test'].includes(process.env.NODE_ENV);
export const screenSizes = {
  screenXs: 480,
  screenSm: 769,
  screenMd: 922,
  screenLg: 1200,
};

export const resizeWindowWidth = (width) => {
  window.innerWidth = width;
  window.dispatchEvent(new Event('resize'));
};

export const hasFeatureEvent = (eventsArray) => {
  const eventsHasFeaturedTile = eventsArray?.some((event) => event.isFeatured);
  const eventsLengthIsFive = eventsArray?.length === 5;
  return eventsHasFeaturedTile && eventsLengthIsFive;
};

export const getSelectedSearchFilters = (filtersArray) =>
  filtersArray?.filter((filter) => filter.selected);

export const getArrayOfSelectedFilterIds = (filtersArray) =>
  filtersArray?.map((filter) => filter.selected && filter.id).filter(Boolean);

export const getEnabledSearchFilters = (filterArray) =>
  filterArray.map((filter) => filter.enabled && filter.description).filter(Boolean);

export const getObjectByValue = (arrayOfObjects, value) => {
  const filteredObj = arrayOfObjects.filter((obj) => obj.key === value);

  return filteredObj;
};

export const getTimeStringAMorPM = (dateString) => {
  const date = new Date(dateString);
  const dateHours = date.getHours();
  const dateMinutes = date.getMinutes();
  const amOrPm = dateHours >= 12 ? 'pm' : 'am';
  const hourDivisibleBy12 = dateHours % 12;
  const hours = hourDivisibleBy12 || 12;
  const minutes = dateMinutes.toString().padStart(2, '0');
  const timeString = `${hours}:${minutes}${amOrPm}`;
  return timeString;
};

export const getDateString = (dateString) => {
  const dayName = new Date(dateString).toLocaleString('default', {
    weekday: 'long',
  });
  const dates = new Date(dateString).toLocaleString('default', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  });
  return `${dayName} ${dates}`;
};

export const getRandomArrayItem = (array) => {
  const maximumRandomNumber = array.length - 1;
  return array[Math.round(Math.random() * maximumRandomNumber)];
};

export const getKeyByValue = (object, value) =>
  Object.keys(object).find((key) => object[key] === value);
